














































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Page, FamiliaDoProduto } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { Pageable } from '@/models/Pageable'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'
import { SaveFamiliaDoProdutoUseCase } from '@/usecases/produto/tipoProduto'

@Component({
	model: {
		prop: 'familia',
	},
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeFamiliaDoProduto extends Vue {
	@Prop({ type: [Object, Array], default: null }) familia!: (string | FamiliaDoProduto) | (string | FamiliaDoProduto)[] | null
	@Prop({ type: Boolean }) podeCriar!: boolean
	@Prop({ type: Boolean }) podeEditar!: boolean
	@Prop({ type: Boolean }) returnObject!: boolean
	@Prop({ type: Boolean }) multiple!: boolean
	busca = ''
	itemEditando: null | ItemSelecao = null
	itensSelecao: ItemSelecao[] = []
	saveFamiliaDoProdutoUseCase = new SaveFamiliaDoProdutoUseCase

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	pagina: Page<FamiliaDoProduto> | null = null
	cancelToken: CancelTokenSource | null = null

	buscandoMaisItens = false
	buscandoNovosItens = true

	created() {
		this.buscarNovosItens()
	}

	familiaEmItemAutocompletar(familia: FamiliaDoProduto | string): ItemSelecao {
		return typeof familia === 'string'
			? {
				id: '',
				nome: familia,
				tipo: 'selecao',
			}
			: {
				...familia,
				tipo: 'selecao',
			}
	}

	get itens() {
		let itens: ItemAutocompletar[] = this.familia === null
			? []
			: (Array.isArray(this.familia)
				? this.familia.map(this.familiaEmItemAutocompletar)
				: [this.familiaEmItemAutocompletar(this.familia)])

		itens = [
			...itens,
			...this.podeCriar
				? [{
					tipo: 'header',
					header: 'Selecione uma opção ou crie uma',
				} as ItemHeader]
				: [],
			...this.itensSelecao,
		]
		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens)
			itens.push({ tipo: 'buscar-mais' })

		const familias = this.familia
		if (!this.podeCriar || !this.busca || this.buscandoNovosItens) return itens
		if (!familias) return [{ tipo: 'novo' }, ...itens]
		if (Array.isArray(familias)) {
			return familias.some(
				familia => this.busca.toLowerCase() === this.obterNomeFamilia(familia).toLowerCase(),
			)
				? itens
				: [{ tipo: 'novo' }, ...itens]
		}
		return this.busca.toLowerCase() === this.obterNomeFamilia(familias).toLowerCase()
			? itens
			: [{ tipo: 'novo' }, ...itens]
	}

	obterNomeFamilia(familia: FamiliaDoProduto | string) {
		return typeof familia === 'string'
			? familia
			: familia.nome
	}

	async selecionaItem(item: ItemSelecao | ItemNovo) {
		if (!item) {
			this.$emit('input', null)
			return
		}

		if (item.tipo === 'novo') {
			await this.criarFamilia()
		} else {
			this.$emit('input', item)
		}
	}

	async criarFamilia() {
		try {
			if (this.busca.trim() == '') return AlertModule.setError("Não pode ser vazio")
			const familiaNova: FamiliaDoProduto = { id: '', nome: this.busca.trim() }

			const familiaCriada = await this.saveFamiliaDoProdutoUseCase.criarFamiliaDoProduto(familiaNova)

			const item: ItemSelecao = { ...familiaCriada, tipo: 'selecao' }
			this.itensSelecao.push(item)
			this.emitirInput(item)

			return familiaCriada
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	emitirInput(item: ItemSelecao) {
		if (!Array.isArray(this.familia)) {
			this.$emit('input', this.returnObject
				? item
				: item.id,
			)
		} else {
			const familias = this.familia || []
			this.$emit('input', [
				...familias,
				item,
			])
		}
	}

	editar(item) {
		this.itemEditando = { ...item }
	}

	async confirmarEdicao() {
		if (!this.itemEditando) {
			return
		}
		if (!this.itemEditando.nome) {
			this.itemEditando = null
			return
		}
		const indice = this.itensSelecao.findIndex(
			item => item.id === this.itemEditando?.id,
		)
		if (indice === -1) return

		this.itensSelecao.splice(indice, 1, this.itemEditando)
		const familiaEditada = {
			id: this.itemEditando.id,
			nome: this.itemEditando.nome,
			lojas: [],
		}
		await this.saveFamiliaDoProdutoUseCase.editarFamiliaDoProduto(familiaEditada)
		this.itemEditando = null
	}

	async buscar(paginavel: Pageable = {}): Promise<FamiliaDoProduto[]> {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.saveFamiliaDoProdutoUseCase.listarFamiliasDoProduto({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
				sort: 'nome',
			}, axiosConfig);
			this.paginacao.page = this.pagina.number
			return this.pagina.content
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const familias = await this.buscar({
			...this.paginacao,
			page: 0,
		})
		this.itensSelecao = []
		this.inserirFamilias(familias)
		this.buscandoNovosItens = false
	}

	async buscarMaisItens() {
		this.buscandoMaisItens = true
		const familias = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})
		this.inserirFamilias(familias)
		this.buscandoMaisItens = false
	}

	inserirFamilias(familias: FamiliaDoProduto[]) {
		this.itensSelecao = [
			...this.itensSelecao,
			...familias.map<ItemSelecao>(item => ({
				...item,
				tipo: 'selecao',
			})),
		]
	}

	@Watch('busca')
	onChangeBusca = this.buscarNovosItens

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoMaisItens) this.buscarMaisItens()
	}
}

export type ItemHeader = {
	tipo: 'header'
	header: string
}

export type ItemSelecao = FamiliaDoProduto & {
	tipo: 'selecao'
}

export type ItemNovo = {
	tipo: 'novo'
	text: string
}

export type ItemBuscarMais = {
	tipo: 'buscar-mais'
}

export type ItemAutocompletar = ItemHeader | ItemSelecao | ItemNovo | ItemBuscarMais
